<template>
  <div class="addAddress absolute">
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">姓名</div>
        <input
          type="text"
          placeholder="请输入姓名"
          v-model="userAddress.real_name"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="select-box">
          <select v-model="userAddress.id_type">
            <option
              v-for="(cardType, index) in cardTypes"
              :value="cardType.value"
              :key="index"
              >{{ cardType.name }}</option
            >
          </select>
          <i></i>
        </div>
        <input
          type="text"
          placeholder="请输入证件号码"
          v-model="userAddress.id_number"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">联系电话</div>
        <input
          type="text"
          placeholder="请输入联系电话"
          v-model="userAddress.phone"
          required
        />
      </div>
      <!--      <div class="item acea-row row-between-wrapper">-->
      <!--        <div class="name">生日</div>-->
      <!--        <DateTime-->
      <!--          type="date"-->
      <!--          start-date="1920-01-01"-->
      <!--          v-model="userAddress.birthday"-->
      <!--        />-->
      <!--      </div>-->
      <div class="item acea-row row-between-wrapper">
        <div class="name">性别</div>
        <RadioGroup class="radio-group" v-model="userAddress.sex" required>
          <Radio val="0">男</Radio>
          <Radio val="1">女</Radio>
        </RadioGroup>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">身高</div>
        <span
          slot="right"
          class="right-item"
          style="padding: 5px 0; line-height: 25px;"
        >
          <RadioGroup
            class="radio-group"
            v-model="userAddress.height_type"
            required
          >
            <Radio
              :val="value"
              v-for="(text, value) in heightType"
              :key="value"
              style="display: block;"
              >{{ text }}</Radio
            >
          </RadioGroup>
        </span>
      </div>
      <!-- <div class="item acea-row row-between-wrapper">
        <div class="name">所在地区</div>
        <div
          class="picker acea-row row-between-wrapper select-value form-control"
        >
          <div class="address">
            <div slot="right" @click.stop="show2 = true">
              {{ model2 || "请选择收货地址" }}
            </div>
            <CitySelect
              v-model="show2"
              :callback="result2"
              :items="district"
              provance=""
              city=""
              area=""
            ></CitySelect>
          </div>
          <div class="iconfont icon-dizhi font-color-red"></div>
        </div>
      </div> -->
      <!-- <div class="item acea-row row-between-wrapper">
        <div class="name">详细地址</div>
        <input
          type="text"
          placeholder="请填写具体地址"
          v-model="userAddress.detail"
          required
        />
      </div> -->
    </div>
    <div class="default acea-row row-middle">
      <div class="select-btn">
        <div class="checkbox-wrapper">
          <label class="well-check"
            ><input
              type="checkbox"
              name=""
              value=""
              @click="ChangeIsDefault"
              :checked="userAddress.is_default ? true : false"
            /><i class="icon"></i
            ><span class="def">设置为默认常用人</span></label
          >
        </div>
      </div>
    </div>
    <div></div>
    <div class="keepBnt bg-color-red" @click="submit">立即保存</div>
    <div
      class="wechatAddress"
      v-if="false && isWechat && !id"
      @click="getAddress"
    >
      导入微信地址
    </div>
  </div>
</template>
<script type="text/babel">
// import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import District from "ydui-district/dist/jd_province_city_area_id";
import { getAddress, postAddress } from "@api/user";
import attrs, { required, chs_phone, num } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { openAddress } from "@libs/wechat";
import { isWeixin } from "@utils";
// import { DateTime } from "vue-ydui/dist/lib.rem/datetime";
import { Radio, RadioGroup } from "vue-ydui/dist/lib.rem/radio";

export default {
  components: {
    // CitySelect,
    // DateTime,
    Radio,
    RadioGroup
  },
  data() {
    return {
      cardTypes: [
        {
          name: "身份证",
          value: 0
        },
        {
          name: "港澳通行证",
          value: 1
        },
        {
          name: "中国护照",
          value: 2
        },
        {
          name: "香港护照",
          value: 3
        },
        {
          name: "澳门护照",
          value: 4
        },
        {
          name: "回乡证",
          value: 5
        },
        {
          name: "台胞证",
          value: 6
        },
        {
          name: "其他证件",
          value: 7
        }
      ],
      show2: false,
      model2: "",
      district: District,
      id: 0,
      userAddress: {
        is_default: 0,
        // birthday: "1980-01-01",
        id_type: 0,
        sex: "0",
        height_type: "adult"
      },
      heightType: {
        adult: "成年人",
        child: "1米2以上未成年",
        baby: "1米2以下未成年"
      },
      address: {},
      isWechat: isWeixin()
    };
  },
  mounted: function() {
    let id = this.$route.params.id;
    this.id = id;
    document.title = !id ? "添加地址" : "修改地址";
    this.getUserAddress();
  },
  methods: {
    getUserAddress: function() {
      if (!this.id) return false;
      let that = this;
      getAddress(that.id).then(res => {
        that.userAddress = res.data;
        that.userAddress.sex = that.userAddress.sex.toString();
        // that.model2 =
        //   res.data.province + " " + res.data.city + " " + res.data.district;
        // that.address.province = res.data.province;
        // that.address.city = res.data.city;
        // that.address.district = res.data.district;
      });
    },
    getAddress() {
      openAddress().then(userInfo => {
        this.$dialog.loading.open();
        postAddress({
          id: this.id,
          real_name: userInfo.userName,
          phone: userInfo.telNumber,
          address: {
            province: userInfo.provinceName,
            city: userInfo.cityName,
            district: userInfo.countryName
          },
          detail: userInfo.detailInfo,
          is_default: 1,
          post_code: userInfo.postalCode
        })
          .then(() => {
            this.$dialog.loading.close();
            this.$dialog.toast({ mes: "添加成功" });
            this.$router.go(-1);
          })
          .catch(err => {
            this.$dialog.loading.close();
            this.$dialog.error(err.msg || "添加失败");
          });
      });
    },
    async submit() {
      let name = this.userAddress.real_name,
        phone = this.userAddress.phone,
        isDefault = this.userAddress.is_default,
        // birthday = this.userAddress.birthday,
        sex = this.userAddress.sex,
        id_number = this.userAddress.id_number,
        height_type = this.userAddress.height_type;

      try {
        await this.$validator({
          name: [
            required(required.message("姓名")),
            attrs.range([2, 16], attrs.range.message("姓名"))
          ],
          // id_number: [required("请输入证件号码")],
          phone: [
            required(required.message("联系电话")),
            chs_phone(chs_phone.message())
          ],
          // birthday: [required("请选择生日")],
          sex: [num("请选择性别")]
        }).validate({ name, id_number, phone, sex });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      try {
        let that = this,
          data = {
            id: that.id,
            real_name: name,
            phone: phone,
            // birthday: birthday,
            sex: sex,
            id_type: that.userAddress.id_type,
            id_number: id_number,
            // address: this.address,
            // detail: detail,
            is_default: isDefault,
            height_type: height_type
            // post_code: ""
          };
        postAddress(data)
          .then(function() {
            if (that.id) that.$dialog.toast({ mes: "修改成功" });
            else that.$dialog.toast({ mes: "添加成功" });
            that.$router.go(-1);
          })
          .catch(e => {
            this.$dialog.error(e.msg);
          });
      } catch (e) {
        this.$dialog.error(e.msg);
      }
    },
    ChangeIsDefault: function() {
      this.userAddress.is_default = !this.userAddress.is_default;
    },
    result2(ret) {
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.district = ret.itemName3;
    }
  }
};
</script>
